<div
  *ngIf="afterImageUrl && beforeImageUrl"
  class="before-after"
  (window:resize)="onResize()"
  (window:mousemove)="slideMove($event)"
  (window:mouseup)="slideFinish($event)"
  (window:touchmove)="slideMove($event)"
  (window:touchend)="slideFinish($event)"
>
  <div
    #beforeImage
    class="before-image"
  >
    <img [src]="beforeImageUrl" loading="lazy">
  </div>
  <div
    #afterImage
    class="after-image"
  >
    <img [src]="afterImageUrl" loading="lazy">
  </div>
  <div
    #slider
    class="slider"
    (mousedown)="slideReady($event)"
    (touchstart)="slideReady($event)"
  >
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/before-after-comparison/before-after-comparison.component.html